<template>
  <section class="point-grid-section" :class="{ tint: tint }">
    <v-container>
      <h2 v-if="title" class="font-sora point-grid__title">{{ title }}</h2>
      <ul class="point-grid" :class="'cols-' + columns">
        <li v-for="(point, i) in points" :key="i">
          <span class="point-grid__mark" aria-hidden="true">✔</span>
          <span>{{ point }}</span>
        </li>
      </ul>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'PointGrid',
  props: {
    title: { type: String, default: '' },
    points: { type: Array, default: () => [] },
    columns: { type: Number, default: 2 },
    tint: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.point-grid-section {
  padding: 40px 0 16px;
}

.point-grid-section.tint {
  background: #f7f9fb;
}

.point-grid__title {
  text-align: center;
  color: var(--brand-navy, #002458);
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 24px;
}

.point-grid {
  list-style: none;
  padding: 0;
  margin: 0 auto;
  max-width: 860px;
  display: grid;
  gap: 12px 24px;
}

.point-grid.cols-2 {
  grid-template-columns: 1fr 1fr;
}

.point-grid.cols-1 {
  grid-template-columns: 1fr;
  max-width: 640px;
}

.point-grid li {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fff;
  border: 1px solid #e6ebf1;
  border-radius: 10px;
  padding: 14px 16px;
  color: var(--brand-navy, #002458);
  font-weight: 600;
  font-size: 15px;
  line-height: 1.4;
}

.point-grid__mark {
  color: var(--brand-teal, #08a0a8);
  flex: 0 0 auto;
}

@media screen and (max-width: 700px) {
  .point-grid.cols-2 {
    grid-template-columns: 1fr;
  }
}
</style>
